import { LightBulbIcon, XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

export const HSE_GUIDE_TOPICS = [
  "risk",
  "sja",
  "chemical",
  "protective",
  "evaluation",
  "tiltak",
  "goals",
];

export function HseGuideButton({ onClick, className = "" }) {
  const { t } = useTranslation();
  return (
    <button
      type="button"
      onClick={onClick}
      className={`inline-flex items-center gap-2 rounded-full border border-violet-200 bg-violet-50 px-3 py-1.5 text-sm font-semibold text-violet-900 hover:bg-violet-100 ${className}`}
    >
      <LightBulbIcon className="h-4 w-4" aria-hidden="true" />
      {t("hse.guide.see")}
    </button>
  );
}

export function HseModuleGuide({ topic = "risk", open, onClose }) {
  const { t } = useTranslation();
  if (!open) return null;

  const safeTopic = HSE_GUIDE_TOPICS.includes(topic) ? topic : "risk";
  const steps = [1, 2, 3]
    .map((index) => t(`hse.guide.${safeTopic}.step${index}`, { defaultValue: "" }))
    .filter(Boolean);

  return (
    <div className="fixed inset-0 z-40 flex justify-end">
      <button
        type="button"
        className="absolute inset-0 bg-slate-900/30"
        aria-label={t("hse.risk.cancel")}
        onClick={onClose}
      />
      <aside
        role="dialog"
        aria-modal="true"
        aria-labelledby="hse-module-guide-title"
        className="relative flex h-full w-full max-w-md flex-col bg-white shadow-2xl"
      >
        <div className="flex items-start justify-between gap-3 border-b border-slate-100 px-5 py-4">
          <div>
            <p className="text-xs font-semibold uppercase tracking-wide text-violet-700">
              {t("hse.guide.badge")}
            </p>
            <h2 id="hse-module-guide-title" className="mt-1 text-lg font-extrabold text-slate-900">
              {t(`hse.guide.${safeTopic}.title`)}
            </h2>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="rounded-lg p-2 text-slate-500 hover:bg-slate-100"
            aria-label={t("hse.risk.cancel")}
          >
            <XMarkIcon className="h-5 w-5" />
          </button>
        </div>
        <div className="flex-1 space-y-4 overflow-y-auto px-5 py-5 text-sm leading-relaxed text-slate-600">
          <p>{t(`hse.guide.${safeTopic}.lead`)}</p>
          {steps.length > 0 ? (
            <ol className="list-decimal space-y-2 pl-5">
              {steps.map((step) => (
                <li key={step}>{step}</li>
              ))}
            </ol>
          ) : null}
        </div>
        <div className="border-t border-slate-100 px-5 py-4">
          <Link
            to={`/dashboard/guide/hse-ks#${safeTopic}`}
            className="text-sm font-semibold text-[#1463C7] hover:underline"
            onClick={onClose}
          >
            {t("hse.guide.open_full")}
          </Link>
        </div>
      </aside>
    </div>
  );
}
